import React, { useEffect, useState } from "react";
import AdminS from "layouts/AdminS";
import Footer from "components/Footer/Footer";

// import { ToastContainer,toast, Zoom, Bounce } from 'react-toastify';
// import "react-toastify/dist/ReactToastify.css";
// import axios from "axios"
// import validator from 'validator'
import {
  Badge,
  Button,
  Card,
  Form,
  Navbar,
  Nav,
  Container,
  Col,
  Table,
  DropdownButton,
  Dropdown,
  FormControl,
  Row,
} from "react-bootstrap";
import firebase from "../firebase";

const ActivateRewards=(props) => {

    const [rAmount,setrAmount] = useState('');
    const [rNum,setrNum] = useState('');
    const [rTime,setrTime] = useState('');

    const [UserName, setuserName] = useState("");
    
    useEffect(()=>{
      setuserName(props.match.params.UserName)
      },[]);

    const handleAddRewards = () =>{
      if(rAmount && rNum && rTime){
      const firestore = firebase.database().ref("/RewardManagement")
      let data = {
        UserName:UserName,
        RAmmount:rAmount,
        RNum: rNum,//num + 1
        RTime:rTime,
      }
      firestore.push(data);
      alert("Succfull added");
      setrNum("");
      setuserName("");
      setrAmount("");
      setrTime("");
      setrTime("");
      }
  
      else {
        alert("Please Fill all the Fields")
      } 
    };
    return (
        <>

<AdminS/>

<br/>


<Container>

  <Row>
    <Col md={{ span: 12, offset: 1 }}>  

        <Container fluid>
        <Row>
          <Col md="11">
            <Card>
              <Card.Header>
                <Card.Title as="h4"></Card.Title>
              </Card.Header>
              <Card.Body>
                <Form>
                <Row>
                    <Form.Label column sm={4}>
                    R Num
                    </Form.Label>
                    <Col className="pr-1" md="6">
                      <Form.Group>
                        <Form.Control
                          defaultValue=""
                          placeholder="Number"
                          type="text"
                          focus value = {rNum} onChange={(e)=>{setrNum(e.target.value);}}
                          required
                        ></Form.Control>
                      </Form.Group>
                    </Col>
                    </Row>

                    <Row>
                    <Form.Label column sm={4}>
                    User Name
                    </Form.Label>
                    <Col className="pr-1" md="6">
                      <Form.Group>
                        <Form.Control
                          defaultValue=""
                          placeholder="User's Name"
                          type="text"
                          focus value = {UserName} onChange={(e)=>{setuserName(e.target.value);}}
                          required
                        ></Form.Control>
                      </Form.Group>
                    </Col>
                    </Row>



                    <Row>
                    <Form.Label column sm={4}>
                    Rewards Amount
                    </Form.Label>
                    <Col className="pr-1" md="6">
                      <Form.Group>
                        <Form.Control
                          defaultValue=""
                          placeholder="Rewards Amount"
                          type="text"
                          focus value = {rAmount} onChange={(e)=>{setrAmount(e.target.value);}}
                          required
                        ></Form.Control>
                      </Form.Group>
                    </Col>
                    </Row>

                    <Row>
                    <Form.Label column sm={4}>
                    Rewards added time
                    </Form.Label>
                    <Col className="pr-1" md="6">
                      <Form.Group>
                        <Form.Control
                          defaultValue=""
                          placeholder="Time"
                          type="time"
                          focus value = {rTime} onChange={(e)=>{setrTime(e.target.value);}}
                          required
                        ></Form.Control>
                      </Form.Group>
                    </Col>
                    </Row>

                    <button onClick={()=>{handleAddRewards()}} type="button" class="btn btn-primary btn-lg btn-block">Activate Rewards</button>                    
                    </Form>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>      
      </Col>
  </Row>

  
</Container>


<Footer />     
        </>
    );
}
export default ActivateRewards;